<template>
    <div>
        <div class="h5">
            {{ statusHeader }}
        </div>
        <envelope-status-text
            v-bind:text="statusDisplay"
            v-bind:status-severity="statusSeverity"
            no-text-color
            bubble-text
            bold />
        <div class="row">
            <div
                v-if="!isEnvelopeComplete"
                v-bind:class="responsiveClasses.infoSection">
                <div class="h5">
                    {{ itemsHeader }}
                </div>
                <div
                    v-for="(item, i) in items"
                    v-bind:key="item.PublicId">
                    <item-status
                        v-bind:item="item"
                        v-bind:item-definition="getItemDefinition(item)"
                        v-bind:get-attachment-by-attachment-id-fn="getAttachmentByAttachmentId"
                        v-bind:get-content-library-item-by-id-fn="getContentLibraryItemByIdFn"
                        v-bind:class="i > 0 ? 'mt-3' : ''" />
                </div>
            </div>
            <div
                v-if="isEnvelopeComplete"
                v-bind:class="responsiveClasses.infoSection">
                <div class="h5">
                    {{ savedDocumentsHeader }}
                </div>
                <envelope-completed-items
                    v-bind:envelope="envelope"
                    v-bind:download-completed-item-fn="downloadCompletedItemFn"
                    v-bind:show-certificate="showCertificate" />
            </div>
            <div
                v-if="!isWetSignEnvelope"
                v-bind:class="responsiveClasses.infoSection">
                <div class="h5">
                    {{ recipientsHeader }}
                </div>
                <div
                    v-for="(recipient, i) in recipients"
                    v-bind:key="recipient.PublicId">
                    <recipient-status
                        v-bind:recipient="recipient"
                        v-bind:recipient-definition="getRecipientDefinition(recipient)"
                        v-bind:class="i > 0 ? 'mt-3' : ''" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        getEnvelopeStatusSeverity,
        getEnvelopeStatusTextBubbleClass,
        isEnvelopeStatusTerminal
    } from "ESignatures/eSignatureConstants";
    import { KEYS, NAMESPACE } from "./i18n/envelopeStatus.i18n";
    import { mapI18n } from "Util/i18n";
    import envelopeStatusText from "Forms/Components/Elements/envelope/envelopeStatusText.vue";
    import itemStatus from "./envelopeItemStatus.vue";
    import recipientStatus from "./envelopeRecipientStatus.vue";
    import envelopeCompletedItems from "Forms/Components/Elements/envelope/envelopeCompletedItems.vue";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        infoSection: {
            col: { xs: 12, md: 6 },
            always: "mt-4"
        }
    };

    export default {
        components: {
            envelopeStatusText,
            itemStatus,
            recipientStatus,
            envelopeCompletedItems
        },
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            envelope: { type: Object, required: true },
            showCertificate: { type: Boolean, required: false, default: false },
            downloadCompletedItemFn: { type: Function, required: true },
            getContentLibraryItemByIdFn: { type: Function, required: true }
        },
        computed: {
            statusCode() {
                return this.envelope.Status.Code;
            },
            statusDisplay() {
                const statusText = this.envelope.Status.Display;
                const statusTimestamp = this.envelope.StatusTimestamp.Display;
                if (statusTimestamp) {
                    return `${statusText}: ${statusTimestamp}`;
                } else {
                    return statusText;
                }
            },
            statusSeverity() {
                return getEnvelopeStatusSeverity(this.statusCode);
            },
            envelopeDefinition() {
                return this.envelope.Definition;
            },
            isWetSignEnvelope() {
                return this.envelope.IsWetSign;
            },
            isEnvelopeComplete() {
                return isEnvelopeStatusTerminal(this.statusCode);
            },
            items() {
                return Object.values(this.envelope.Items);
            },
            recipients() {
                return Object.values(this.envelope.Recipients);
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            getItemDefinition(item) {
                return this.envelopeDefinition.Items[item.DefinitionId];
            },
            getRecipientDefinition(recipient) {
                return this.envelopeDefinition.Recipients[recipient.DefinitionId];
            },
            getAttachmentByAttachmentId(attachmentId) {
                return this.envelope.AttachmentsById[attachmentId];
            },
            getEnvelopeStatusTextBubbleClass
        }
    };
</script>
